/* Sagevow: close the cart drawer and return to browsing.
   Falls back to the collections page when the drawer is not present (cart page). */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-sv-keep-shopping]');
  if (!trigger) return;
  event.preventDefault();

  var drawer = document.querySelector('cart-drawer-component, dialog[open], .cart-drawer');
  var closer = drawer && drawer.querySelector('[aria-label*="Close" i], .cart-drawer__close, button[data-close]');

  if (closer) { closer.click(); return; }
  if (drawer && typeof drawer.close === 'function') { drawer.close(); return; }
  window.location.href = '/collections/all';
});
